import { useCallback, useState } from 'react';

export interface UseOpenResult {
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  handleToggle: () => void;
}

export const useOpen = (initialOpen: boolean = false): UseOpenResult => {
  const [isOpen, setIsOpen] = useState<boolean>(initialOpen);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return {
    isOpen,
    handleOpen,
    handleClose,
    handleToggle,
  };
};
